"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Wholesale Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@deliverr.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceApi = exports.ServiceApiFactory = exports.ServiceApiFp = exports.ServiceApiAxiosParamCreator = void 0;
const axios_1 = __importDefault(require("axios"));
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * ServiceApi - axios parameter creator
 * @export
 */
const ServiceApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {WholesaleOrderAugmentRequestDTO} wholesaleOrderAugmentRequestDTO
         * @param {QuantityRoundingStrategy} [quantityRoundingStrategy]
         * @param {InventoryMissingStrategy} [inventoryRoundingStrategy]
         * @param {ParcelStrategyType} [parcelStrategy]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        augmentOrder: async (wholesaleOrderAugmentRequestDTO, quantityRoundingStrategy, inventoryRoundingStrategy, parcelStrategy, options = {}) => {
            // verify required parameter 'wholesaleOrderAugmentRequestDTO' is not null or undefined
            (0, common_1.assertParamExists)('augmentOrder', 'wholesaleOrderAugmentRequestDTO', wholesaleOrderAugmentRequestDTO);
            const localVarPath = `/orders/augment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            // authentication cognito required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "authorization", configuration);
            if (quantityRoundingStrategy !== undefined) {
                localVarQueryParameter['quantityRoundingStrategy'] = quantityRoundingStrategy;
            }
            if (inventoryRoundingStrategy !== undefined) {
                localVarQueryParameter['inventoryRoundingStrategy'] = inventoryRoundingStrategy;
            }
            if (parcelStrategy !== undefined) {
                localVarQueryParameter['parcelStrategy'] = parcelStrategy;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(wholesaleOrderAugmentRequestDTO, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} orderId
         * @param {string} [xDeliverrSellerId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelOrderAndShipments: async (orderId, xDeliverrSellerId, options = {}) => {
            // verify required parameter 'orderId' is not null or undefined
            (0, common_1.assertParamExists)('cancelOrderAndShipments', 'orderId', orderId);
            const localVarPath = `/orders/{orderId}/cancel`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            // authentication cognito required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "authorization", configuration);
            if (xDeliverrSellerId !== undefined && xDeliverrSellerId !== null) {
                localVarHeaderParameter['x-deliverr-seller-id'] = String(xDeliverrSellerId);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} transferId
         * @param {string} xDeliverrSellerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelTransferAndShipments: async (transferId, xDeliverrSellerId, options = {}) => {
            // verify required parameter 'transferId' is not null or undefined
            (0, common_1.assertParamExists)('cancelTransferAndShipments', 'transferId', transferId);
            // verify required parameter 'xDeliverrSellerId' is not null or undefined
            (0, common_1.assertParamExists)('cancelTransferAndShipments', 'xDeliverrSellerId', xDeliverrSellerId);
            const localVarPath = `/transfer/{transferId}/cancel`
                .replace(`{${"transferId"}}`, encodeURIComponent(String(transferId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            // authentication cognito required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "authorization", configuration);
            if (xDeliverrSellerId !== undefined && xDeliverrSellerId !== null) {
                localVarHeaderParameter['x-deliverr-seller-id'] = String(xDeliverrSellerId);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} xDeliverrSellerId
         * @param {WholesaleOrderUpsertRequestDTO} wholesaleOrderUpsertRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrderAndShipments: async (xDeliverrSellerId, wholesaleOrderUpsertRequestDTO, options = {}) => {
            // verify required parameter 'xDeliverrSellerId' is not null or undefined
            (0, common_1.assertParamExists)('createOrderAndShipments', 'xDeliverrSellerId', xDeliverrSellerId);
            // verify required parameter 'wholesaleOrderUpsertRequestDTO' is not null or undefined
            (0, common_1.assertParamExists)('createOrderAndShipments', 'wholesaleOrderUpsertRequestDTO', wholesaleOrderUpsertRequestDTO);
            const localVarPath = `/orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            // authentication cognito required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "authorization", configuration);
            if (xDeliverrSellerId !== undefined && xDeliverrSellerId !== null) {
                localVarHeaderParameter['x-deliverr-seller-id'] = String(xDeliverrSellerId);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(wholesaleOrderUpsertRequestDTO, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} xDeliverrSellerId
         * @param {WholesaleOrderUpsertRequestDTO} wholesaleOrderUpsertRequestDTO
         * @param {boolean} [submitOrder]
         * @param {boolean} [validateAddress]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrderAndShipmentsInternal: async (xDeliverrSellerId, wholesaleOrderUpsertRequestDTO, submitOrder, validateAddress, options = {}) => {
            // verify required parameter 'xDeliverrSellerId' is not null or undefined
            (0, common_1.assertParamExists)('createOrderAndShipmentsInternal', 'xDeliverrSellerId', xDeliverrSellerId);
            // verify required parameter 'wholesaleOrderUpsertRequestDTO' is not null or undefined
            (0, common_1.assertParamExists)('createOrderAndShipmentsInternal', 'wholesaleOrderUpsertRequestDTO', wholesaleOrderUpsertRequestDTO);
            const localVarPath = `/orders/internal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            // authentication cognito required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "authorization", configuration);
            if (submitOrder !== undefined) {
                localVarQueryParameter['submitOrder'] = submitOrder;
            }
            if (validateAddress !== undefined) {
                localVarQueryParameter['validateAddress'] = validateAddress;
            }
            if (xDeliverrSellerId !== undefined && xDeliverrSellerId !== null) {
                localVarHeaderParameter['x-deliverr-seller-id'] = String(xDeliverrSellerId);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(wholesaleOrderUpsertRequestDTO, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} xDeliverrSellerId
         * @param {WholesaleOrderUpsertRequestDTO} wholesaleOrderUpsertRequestDTO
         * @param {boolean} [submitOrder]
         * @param {boolean} [validateAddress]
         * @param {boolean} [validateInventory]
         * @param {boolean} [partialFill]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrderAndShipmentsSync: async (xDeliverrSellerId, wholesaleOrderUpsertRequestDTO, submitOrder, validateAddress, validateInventory, partialFill, options = {}) => {
            // verify required parameter 'xDeliverrSellerId' is not null or undefined
            (0, common_1.assertParamExists)('createOrderAndShipmentsSync', 'xDeliverrSellerId', xDeliverrSellerId);
            // verify required parameter 'wholesaleOrderUpsertRequestDTO' is not null or undefined
            (0, common_1.assertParamExists)('createOrderAndShipmentsSync', 'wholesaleOrderUpsertRequestDTO', wholesaleOrderUpsertRequestDTO);
            const localVarPath = `/orders/internal/sync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            // authentication cognito required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "authorization", configuration);
            if (submitOrder !== undefined) {
                localVarQueryParameter['submitOrder'] = submitOrder;
            }
            if (validateAddress !== undefined) {
                localVarQueryParameter['validateAddress'] = validateAddress;
            }
            if (validateInventory !== undefined) {
                localVarQueryParameter['validateInventory'] = validateInventory;
            }
            if (partialFill !== undefined) {
                localVarQueryParameter['partialFill'] = partialFill;
            }
            if (xDeliverrSellerId !== undefined && xDeliverrSellerId !== null) {
                localVarHeaderParameter['x-deliverr-seller-id'] = String(xDeliverrSellerId);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(wholesaleOrderUpsertRequestDTO, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} transferId
         * @param {string} xDeliverrSellerId
         * @param {WholesaleOrderCreationRequestDTO} wholesaleOrderCreationRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTransfer: async (transferId, xDeliverrSellerId, wholesaleOrderCreationRequestDTO, options = {}) => {
            // verify required parameter 'transferId' is not null or undefined
            (0, common_1.assertParamExists)('createTransfer', 'transferId', transferId);
            // verify required parameter 'xDeliverrSellerId' is not null or undefined
            (0, common_1.assertParamExists)('createTransfer', 'xDeliverrSellerId', xDeliverrSellerId);
            // verify required parameter 'wholesaleOrderCreationRequestDTO' is not null or undefined
            (0, common_1.assertParamExists)('createTransfer', 'wholesaleOrderCreationRequestDTO', wholesaleOrderCreationRequestDTO);
            const localVarPath = `/transfer/{transferId}`
                .replace(`{${"transferId"}}`, encodeURIComponent(String(transferId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            // authentication cognito required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "authorization", configuration);
            if (xDeliverrSellerId !== undefined && xDeliverrSellerId !== null) {
                localVarHeaderParameter['x-deliverr-seller-id'] = String(xDeliverrSellerId);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(wholesaleOrderCreationRequestDTO, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} shipmentId
         * @param {AttachmentType} attachmentType
         * @param {string} [orderId]
         * @param {string} [xDeliverrSellerId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLabel: async (shipmentId, attachmentType, orderId, xDeliverrSellerId, options = {}) => {
            // verify required parameter 'shipmentId' is not null or undefined
            (0, common_1.assertParamExists)('deleteLabel', 'shipmentId', shipmentId);
            // verify required parameter 'attachmentType' is not null or undefined
            (0, common_1.assertParamExists)('deleteLabel', 'attachmentType', attachmentType);
            const localVarPath = `/shipments/{shipmentId}/attachments/{attachmentType}`
                .replace(`{${"shipmentId"}}`, encodeURIComponent(String(shipmentId)))
                .replace(`{${"attachmentType"}}`, encodeURIComponent(String(attachmentType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            // authentication cognito required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "authorization", configuration);
            if (orderId !== undefined) {
                localVarQueryParameter['orderId'] = orderId;
            }
            if (xDeliverrSellerId !== undefined && xDeliverrSellerId !== null) {
                localVarHeaderParameter['x-deliverr-seller-id'] = String(xDeliverrSellerId);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {PurchaseLabelDTO} purchaseLabelDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateCaseLabelPdf: async (purchaseLabelDTO, options = {}) => {
            // verify required parameter 'purchaseLabelDTO' is not null or undefined
            (0, common_1.assertParamExists)('generateCaseLabelPdf', 'purchaseLabelDTO', purchaseLabelDTO);
            const localVarPath = `/shipments/unit-pick/generateCaseLabelPdf`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            // authentication cognito required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(purchaseLabelDTO, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} shipmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateShipmentPackingList: async (shipmentId, options = {}) => {
            // verify required parameter 'shipmentId' is not null or undefined
            (0, common_1.assertParamExists)('generateShipmentPackingList', 'shipmentId', shipmentId);
            const localVarPath = `/v2/shipments/packing-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            // authentication cognito required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "authorization", configuration);
            if (shipmentId !== undefined) {
                localVarQueryParameter['shipmentId'] = shipmentId;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHealthStatus: async (options = {}) => {
            const localVarPath = `/health`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            // authentication cognito required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "authorization", configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * returns the avialble inventory for a given SKU list in context of a specific sourceWarehouse and destinationChannelId
         * @summary get available inventory for a given SKU
         * @param {Array<string>} dskus the list of SKUs to be searched for inventory
         * @param {ExternalDestinationType} [targetId] the target to search for inventory
         * @param {Array<string>} [sourceWarehouses] warehouseIds to search for inventory
         * @param {InventoryPool} [inventoryPool] choose what kind of inventory pool to use (Defaults to STORAGE)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInventory: async (dskus, targetId, sourceWarehouses, inventoryPool, options = {}) => {
            // verify required parameter 'dskus' is not null or undefined
            (0, common_1.assertParamExists)('getInventory', 'dskus', dskus);
            const localVarPath = `/inventory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            // authentication cognito required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "authorization", configuration);
            if (dskus) {
                localVarQueryParameter['dskus'] = dskus;
            }
            if (targetId !== undefined) {
                localVarQueryParameter['targetId'] = targetId;
            }
            if (sourceWarehouses) {
                localVarQueryParameter['sourceWarehouses'] = sourceWarehouses;
            }
            if (inventoryPool !== undefined) {
                localVarQueryParameter['inventoryPool'] = inventoryPool;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} orderId
         * @param {string} [xDeliverrSellerId]
         * @param {WholeEventVisibilityScope} [eventVisibility]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderAndShipments: async (orderId, xDeliverrSellerId, eventVisibility, options = {}) => {
            // verify required parameter 'orderId' is not null or undefined
            (0, common_1.assertParamExists)('getOrderAndShipments', 'orderId', orderId);
            const localVarPath = `/orders/{orderId}`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            // authentication cognito required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "authorization", configuration);
            if (eventVisibility !== undefined) {
                localVarQueryParameter['eventVisibility'] = eventVisibility;
            }
            if (xDeliverrSellerId !== undefined && xDeliverrSellerId !== null) {
                localVarHeaderParameter['x-deliverr-seller-id'] = String(xDeliverrSellerId);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} shipmentId
         * @param {string} [xDeliverrSellerId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderAndShipmentsByShipmentId: async (shipmentId, xDeliverrSellerId, options = {}) => {
            // verify required parameter 'shipmentId' is not null or undefined
            (0, common_1.assertParamExists)('getOrderAndShipmentsByShipmentId', 'shipmentId', shipmentId);
            const localVarPath = `/orders/byShipment/{shipmentId}`
                .replace(`{${"shipmentId"}}`, encodeURIComponent(String(shipmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            // authentication cognito required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "authorization", configuration);
            if (xDeliverrSellerId !== undefined && xDeliverrSellerId !== null) {
                localVarHeaderParameter['x-deliverr-seller-id'] = String(xDeliverrSellerId);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {WholesaleOrderStatus} [orderStatus]
         * @param {ExternalDestinationType} [externalDestinationType]
         * @param {string} [externalId]
         * @param {boolean} [includeArchived]
         * @param {string} [xDeliverrSellerId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrdersAndShipments: async (orderStatus, externalDestinationType, externalId, includeArchived, xDeliverrSellerId, options = {}) => {
            const localVarPath = `/orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            // authentication cognito required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "authorization", configuration);
            if (orderStatus !== undefined) {
                localVarQueryParameter['orderStatus'] = orderStatus;
            }
            if (externalDestinationType !== undefined) {
                localVarQueryParameter['externalDestinationType'] = externalDestinationType;
            }
            if (externalId !== undefined) {
                localVarQueryParameter['externalId'] = externalId;
            }
            if (includeArchived !== undefined) {
                localVarQueryParameter['includeArchived'] = includeArchived;
            }
            if (xDeliverrSellerId !== undefined && xDeliverrSellerId !== null) {
                localVarHeaderParameter['x-deliverr-seller-id'] = String(xDeliverrSellerId);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} shipmentId
         * @param {string} [xDeliverrSellerId]
         * @param {string} [orderId]
         * @param {WholeEventVisibilityScope} [eventVisibility]
         * @param {boolean} [skipAttachmentByWarehouseType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShipmentAdminAccess: async (shipmentId, xDeliverrSellerId, orderId, eventVisibility, skipAttachmentByWarehouseType, options = {}) => {
            // verify required parameter 'shipmentId' is not null or undefined
            (0, common_1.assertParamExists)('getShipmentAdminAccess', 'shipmentId', shipmentId);
            const localVarPath = `/shipments/{shipmentId}`
                .replace(`{${"shipmentId"}}`, encodeURIComponent(String(shipmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            // authentication cognito required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "authorization", configuration);
            if (orderId !== undefined) {
                localVarQueryParameter['orderId'] = orderId;
            }
            if (eventVisibility !== undefined) {
                localVarQueryParameter['eventVisibility'] = eventVisibility;
            }
            if (skipAttachmentByWarehouseType !== undefined) {
                localVarQueryParameter['skipAttachmentByWarehouseType'] = skipAttachmentByWarehouseType;
            }
            if (xDeliverrSellerId !== undefined && xDeliverrSellerId !== null) {
                localVarHeaderParameter['x-deliverr-seller-id'] = String(xDeliverrSellerId);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} fulfillmentId
         * @param {string} [xDeliverrSellerId]
         * @param {string} [orderId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShipmentByFulfillmentAdminAccess: async (fulfillmentId, xDeliverrSellerId, orderId, options = {}) => {
            // verify required parameter 'fulfillmentId' is not null or undefined
            (0, common_1.assertParamExists)('getShipmentByFulfillmentAdminAccess', 'fulfillmentId', fulfillmentId);
            const localVarPath = `/shipments/shipment/byFulfillmentOrderId/{fulfillmentId}`
                .replace(`{${"fulfillmentId"}}`, encodeURIComponent(String(fulfillmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            // authentication cognito required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "authorization", configuration);
            if (orderId !== undefined) {
                localVarQueryParameter['orderId'] = orderId;
            }
            if (xDeliverrSellerId !== undefined && xDeliverrSellerId !== null) {
                localVarHeaderParameter['x-deliverr-seller-id'] = String(xDeliverrSellerId);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<ShipmentProjectionKeys>} [projectionKeys]
         * @param {WholesaleShipmentStatus} [status]
         * @param {string} [originWarehouseId]
         * @param {Array<string>} [orderIds]
         * @param {WholesaleShippingMethod} [shippingMethod]
         * @param {WholesaleShipmentType} [shipmentType]
         * @param {OrderByColumn} [orderByColumn]
         * @param {OrderByDirection} [orderByDirection]
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getShipments: async (projectionKeys, status, originWarehouseId, orderIds, shippingMethod, shipmentType, orderByColumn, orderByDirection, limit, offset, options = {}) => {
            const localVarPath = `/shipments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            // authentication cognito required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "authorization", configuration);
            if (projectionKeys) {
                localVarQueryParameter['projectionKeys'] = projectionKeys;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (originWarehouseId !== undefined) {
                localVarQueryParameter['originWarehouseId'] = originWarehouseId;
            }
            if (orderIds) {
                localVarQueryParameter['orderIds'] = orderIds;
            }
            if (shippingMethod !== undefined) {
                localVarQueryParameter['shippingMethod'] = shippingMethod;
            }
            if (shipmentType !== undefined) {
                localVarQueryParameter['shipmentType'] = shipmentType;
            }
            if (orderByColumn !== undefined) {
                localVarQueryParameter['orderByColumn'] = orderByColumn;
            }
            if (orderByDirection !== undefined) {
                localVarQueryParameter['orderByDirection'] = orderByDirection;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<ShipmentProjectionKeys>} [projectionKeys]
         * @param {Array<WholesaleShipmentStatus>} [statuses]
         * @param {Array<string>} [originWarehouseIds]
         * @param {Array<string>} [orderIds]
         * @param {Array<WholesaleShippingMethod>} [shippingMethods]
         * @param {Array<WholesaleShipmentType>} [shipmentTypes]
         * @param {OrderByColumn} [orderByColumn]
         * @param {OrderByDirection} [orderByDirection]
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {string} [searchByExternalAttributeKey]
         * @param {string} [searchByExternalAttributeValue]
         * @param {WholeEventVisibilityScope} [eventVisibility]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShipmentsV2: async (projectionKeys, statuses, originWarehouseIds, orderIds, shippingMethods, shipmentTypes, orderByColumn, orderByDirection, limit, offset, searchByExternalAttributeKey, searchByExternalAttributeValue, eventVisibility, options = {}) => {
            const localVarPath = `/v2/shipments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            // authentication cognito required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "authorization", configuration);
            if (projectionKeys) {
                localVarQueryParameter['projectionKeys'] = projectionKeys;
            }
            if (statuses) {
                localVarQueryParameter['statuses'] = statuses;
            }
            if (originWarehouseIds) {
                localVarQueryParameter['originWarehouseIds'] = originWarehouseIds;
            }
            if (orderIds) {
                localVarQueryParameter['orderIds'] = orderIds;
            }
            if (shippingMethods) {
                localVarQueryParameter['shippingMethods'] = shippingMethods;
            }
            if (shipmentTypes) {
                localVarQueryParameter['shipmentTypes'] = shipmentTypes;
            }
            if (orderByColumn !== undefined) {
                localVarQueryParameter['orderByColumn'] = orderByColumn;
            }
            if (orderByDirection !== undefined) {
                localVarQueryParameter['orderByDirection'] = orderByDirection;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (searchByExternalAttributeKey !== undefined) {
                localVarQueryParameter['searchByExternalAttributeKey'] = searchByExternalAttributeKey;
            }
            if (searchByExternalAttributeValue !== undefined) {
                localVarQueryParameter['searchByExternalAttributeValue'] = searchByExternalAttributeValue;
            }
            if (eventVisibility !== undefined) {
                localVarQueryParameter['eventVisibility'] = eventVisibility;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ExternalDestinationType} externalDestinationType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getValidAttributesV2: async (externalDestinationType, options = {}) => {
            // verify required parameter 'externalDestinationType' is not null or undefined
            (0, common_1.assertParamExists)('getValidAttributesV2', 'externalDestinationType', externalDestinationType);
            const localVarPath = `/orders/validAttributes/{externalDestinationType}`
                .replace(`{${"externalDestinationType"}}`, encodeURIComponent(String(externalDestinationType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            // authentication cognito required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "authorization", configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} shipmentId
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getValidShipBy: async (shipmentId, options = {}) => {
            // verify required parameter 'shipmentId' is not null or undefined
            (0, common_1.assertParamExists)('getValidShipBy', 'shipmentId', shipmentId);
            const localVarPath = `/shipments/{shipmentId}/validShipBy`
                .replace(`{${"shipmentId"}}`, encodeURIComponent(String(shipmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            // authentication cognito required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "authorization", configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [shipmentId]
         * @param {string} [originWarehouseId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getValidShipByV2: async (shipmentId, originWarehouseId, options = {}) => {
            const localVarPath = `/warehouse/validShipBy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            // authentication cognito required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "authorization", configuration);
            if (shipmentId !== undefined) {
                localVarQueryParameter['shipmentId'] = shipmentId;
            }
            if (originWarehouseId !== undefined) {
                localVarQueryParameter['originWarehouseId'] = originWarehouseId;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} orderId
         * @param {WholesaleShipmentCreationRequestDTO} wholesaleShipmentCreationRequestDTO
         * @param {string} [xDeliverrSellerId]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        overrideShipments: async (orderId, wholesaleShipmentCreationRequestDTO, xDeliverrSellerId, options = {}) => {
            // verify required parameter 'orderId' is not null or undefined
            (0, common_1.assertParamExists)('overrideShipments', 'orderId', orderId);
            // verify required parameter 'wholesaleShipmentCreationRequestDTO' is not null or undefined
            (0, common_1.assertParamExists)('overrideShipments', 'wholesaleShipmentCreationRequestDTO', wholesaleShipmentCreationRequestDTO);
            const localVarPath = `/orders/{orderId}/overrideShipmentInstructions`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            // authentication cognito required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "authorization", configuration);
            if (xDeliverrSellerId !== undefined && xDeliverrSellerId !== null) {
                localVarHeaderParameter['x-deliverr-seller-id'] = String(xDeliverrSellerId);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(wholesaleShipmentCreationRequestDTO, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} orderId
         * @param {WholesaleOrderPatchDTO} wholesaleOrderPatchDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchOrderAdminAccess: async (orderId, wholesaleOrderPatchDTO, options = {}) => {
            // verify required parameter 'orderId' is not null or undefined
            (0, common_1.assertParamExists)('patchOrderAdminAccess', 'orderId', orderId);
            // verify required parameter 'wholesaleOrderPatchDTO' is not null or undefined
            (0, common_1.assertParamExists)('patchOrderAdminAccess', 'wholesaleOrderPatchDTO', wholesaleOrderPatchDTO);
            const localVarPath = `/orders/{orderId}`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            // authentication cognito required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(wholesaleOrderPatchDTO, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} orderId
         * @param {WholesaleOrderSellerPatchDTO} wholesaleOrderSellerPatchDTO
         * @param {string} [xDeliverrSellerId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchOrderSellerAccess: async (orderId, wholesaleOrderSellerPatchDTO, xDeliverrSellerId, options = {}) => {
            // verify required parameter 'orderId' is not null or undefined
            (0, common_1.assertParamExists)('patchOrderSellerAccess', 'orderId', orderId);
            // verify required parameter 'wholesaleOrderSellerPatchDTO' is not null or undefined
            (0, common_1.assertParamExists)('patchOrderSellerAccess', 'wholesaleOrderSellerPatchDTO', wholesaleOrderSellerPatchDTO);
            const localVarPath = `/orders/seller/{orderId}`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            // authentication cognito required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "authorization", configuration);
            if (xDeliverrSellerId !== undefined && xDeliverrSellerId !== null) {
                localVarHeaderParameter['x-deliverr-seller-id'] = String(xDeliverrSellerId);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(wholesaleOrderSellerPatchDTO, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} shipmentId
         * @param {WholesaleShipmentPatchDTO} wholesaleShipmentPatchDTO
         * @param {string} [xDeliverrSellerId]
         * @param {string} [orderId]
         * @param {boolean} [shouldRerunEstimations]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchShipmentAdminAccess: async (shipmentId, wholesaleShipmentPatchDTO, xDeliverrSellerId, orderId, shouldRerunEstimations, options = {}) => {
            // verify required parameter 'shipmentId' is not null or undefined
            (0, common_1.assertParamExists)('patchShipmentAdminAccess', 'shipmentId', shipmentId);
            // verify required parameter 'wholesaleShipmentPatchDTO' is not null or undefined
            (0, common_1.assertParamExists)('patchShipmentAdminAccess', 'wholesaleShipmentPatchDTO', wholesaleShipmentPatchDTO);
            const localVarPath = `/shipments/{shipmentId}`
                .replace(`{${"shipmentId"}}`, encodeURIComponent(String(shipmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            // authentication cognito required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "authorization", configuration);
            if (orderId !== undefined) {
                localVarQueryParameter['orderId'] = orderId;
            }
            if (shouldRerunEstimations !== undefined) {
                localVarQueryParameter['shouldRerunEstimations'] = shouldRerunEstimations;
            }
            if (xDeliverrSellerId !== undefined && xDeliverrSellerId !== null) {
                localVarHeaderParameter['x-deliverr-seller-id'] = String(xDeliverrSellerId);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(wholesaleShipmentPatchDTO, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} orderId
         * @param {WholesaleTestOrderPatchDTO} wholesaleTestOrderPatchDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchTestOrderAdminAccess: async (orderId, wholesaleTestOrderPatchDTO, options = {}) => {
            // verify required parameter 'orderId' is not null or undefined
            (0, common_1.assertParamExists)('patchTestOrderAdminAccess', 'orderId', orderId);
            // verify required parameter 'wholesaleTestOrderPatchDTO' is not null or undefined
            (0, common_1.assertParamExists)('patchTestOrderAdminAccess', 'wholesaleTestOrderPatchDTO', wholesaleTestOrderPatchDTO);
            const localVarPath = `/orders/test/{orderId}`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            // authentication cognito required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(wholesaleTestOrderPatchDTO, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} shipmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        printCaseLabelPdf: async (shipmentId, options = {}) => {
            // verify required parameter 'shipmentId' is not null or undefined
            (0, common_1.assertParamExists)('printCaseLabelPdf', 'shipmentId', shipmentId);
            const localVarPath = `/shipments/unit-pick/{shipmentId}/printCaseLabelPdf`
                .replace(`{${"shipmentId"}}`, encodeURIComponent(String(shipmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            // authentication cognito required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "authorization", configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {PurchaseLabelDTO} purchaseLabelDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        purchaseLabel: async (purchaseLabelDTO, options = {}) => {
            // verify required parameter 'purchaseLabelDTO' is not null or undefined
            (0, common_1.assertParamExists)('purchaseLabel', 'purchaseLabelDTO', purchaseLabelDTO);
            const localVarPath = `/shipments/purchaseLabel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            // authentication cognito required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(purchaseLabelDTO, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {InternalOpsSupportReleaseShipmentsDTO} internalOpsSupportReleaseShipmentsDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        releaseShipments: async (internalOpsSupportReleaseShipmentsDTO, options = {}) => {
            // verify required parameter 'internalOpsSupportReleaseShipmentsDTO' is not null or undefined
            (0, common_1.assertParamExists)('releaseShipments', 'internalOpsSupportReleaseShipmentsDTO', internalOpsSupportReleaseShipmentsDTO);
            const localVarPath = `/internalOpsSupport/releaseShipments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            // authentication cognito required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(internalOpsSupportReleaseShipmentsDTO, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} shipmentId
         * @param {AttachmentType} attachmentType
         * @param {string} [orderId]
         * @param {string} [xDeliverrSellerId]
         * @param {AttachmentMetaDataDTO} [attachmentMetaDataDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestLabelUploadAdminAccess: async (shipmentId, attachmentType, orderId, xDeliverrSellerId, attachmentMetaDataDTO, options = {}) => {
            // verify required parameter 'shipmentId' is not null or undefined
            (0, common_1.assertParamExists)('requestLabelUploadAdminAccess', 'shipmentId', shipmentId);
            // verify required parameter 'attachmentType' is not null or undefined
            (0, common_1.assertParamExists)('requestLabelUploadAdminAccess', 'attachmentType', attachmentType);
            const localVarPath = `/shipments/{shipmentId}/attachments/{attachmentType}`
                .replace(`{${"shipmentId"}}`, encodeURIComponent(String(shipmentId)))
                .replace(`{${"attachmentType"}}`, encodeURIComponent(String(attachmentType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            // authentication cognito required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "authorization", configuration);
            if (orderId !== undefined) {
                localVarQueryParameter['orderId'] = orderId;
            }
            if (xDeliverrSellerId !== undefined && xDeliverrSellerId !== null) {
                localVarHeaderParameter['x-deliverr-seller-id'] = String(xDeliverrSellerId);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(attachmentMetaDataDTO, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} orderId
         * @param {string} [xDeliverrSellerId]
         * @param {boolean} [validateAddress]
         * @param {boolean} [partialFill]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitOrderAndShipments: async (orderId, xDeliverrSellerId, validateAddress, partialFill, options = {}) => {
            // verify required parameter 'orderId' is not null or undefined
            (0, common_1.assertParamExists)('submitOrderAndShipments', 'orderId', orderId);
            const localVarPath = `/orders/{orderId}/submit`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            // authentication cognito required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "authorization", configuration);
            if (validateAddress !== undefined) {
                localVarQueryParameter['validateAddress'] = validateAddress;
            }
            if (partialFill !== undefined) {
                localVarQueryParameter['partialFill'] = partialFill;
            }
            if (xDeliverrSellerId !== undefined && xDeliverrSellerId !== null) {
                localVarHeaderParameter['x-deliverr-seller-id'] = String(xDeliverrSellerId);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} orderId
         * @param {string} xDeliverrSellerId
         * @param {WholesaleOrderUpsertRequestDTO} wholesaleOrderUpsertRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrderAndShipments: async (orderId, xDeliverrSellerId, wholesaleOrderUpsertRequestDTO, options = {}) => {
            // verify required parameter 'orderId' is not null or undefined
            (0, common_1.assertParamExists)('updateOrderAndShipments', 'orderId', orderId);
            // verify required parameter 'xDeliverrSellerId' is not null or undefined
            (0, common_1.assertParamExists)('updateOrderAndShipments', 'xDeliverrSellerId', xDeliverrSellerId);
            // verify required parameter 'wholesaleOrderUpsertRequestDTO' is not null or undefined
            (0, common_1.assertParamExists)('updateOrderAndShipments', 'wholesaleOrderUpsertRequestDTO', wholesaleOrderUpsertRequestDTO);
            const localVarPath = `/orders/{orderId}`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            // authentication cognito required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "authorization", configuration);
            if (xDeliverrSellerId !== undefined && xDeliverrSellerId !== null) {
                localVarHeaderParameter['x-deliverr-seller-id'] = String(xDeliverrSellerId);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(wholesaleOrderUpsertRequestDTO, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {boolean} [fetchValidatedAddress]
         * @param {DeliverrAddress} [deliverrAddress]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateAddress: async (fetchValidatedAddress, deliverrAddress, options = {}) => {
            const localVarPath = `/validate/address`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            // authentication cognito required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "authorization", configuration);
            if (fetchValidatedAddress !== undefined) {
                localVarQueryParameter['fetchValidatedAddress'] = fetchValidatedAddress;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(deliverrAddress, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.ServiceApiAxiosParamCreator = ServiceApiAxiosParamCreator;
/**
 * ServiceApi - functional programming interface
 * @export
 */
const ServiceApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.ServiceApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {WholesaleOrderAugmentRequestDTO} wholesaleOrderAugmentRequestDTO
         * @param {QuantityRoundingStrategy} [quantityRoundingStrategy]
         * @param {InventoryMissingStrategy} [inventoryRoundingStrategy]
         * @param {ParcelStrategyType} [parcelStrategy]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async augmentOrder(wholesaleOrderAugmentRequestDTO, quantityRoundingStrategy, inventoryRoundingStrategy, parcelStrategy, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.augmentOrder(wholesaleOrderAugmentRequestDTO, quantityRoundingStrategy, inventoryRoundingStrategy, parcelStrategy, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} orderId
         * @param {string} [xDeliverrSellerId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelOrderAndShipments(orderId, xDeliverrSellerId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelOrderAndShipments(orderId, xDeliverrSellerId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} transferId
         * @param {string} xDeliverrSellerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelTransferAndShipments(transferId, xDeliverrSellerId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelTransferAndShipments(transferId, xDeliverrSellerId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} xDeliverrSellerId
         * @param {WholesaleOrderUpsertRequestDTO} wholesaleOrderUpsertRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOrderAndShipments(xDeliverrSellerId, wholesaleOrderUpsertRequestDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOrderAndShipments(xDeliverrSellerId, wholesaleOrderUpsertRequestDTO, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} xDeliverrSellerId
         * @param {WholesaleOrderUpsertRequestDTO} wholesaleOrderUpsertRequestDTO
         * @param {boolean} [submitOrder]
         * @param {boolean} [validateAddress]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOrderAndShipmentsInternal(xDeliverrSellerId, wholesaleOrderUpsertRequestDTO, submitOrder, validateAddress, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOrderAndShipmentsInternal(xDeliverrSellerId, wholesaleOrderUpsertRequestDTO, submitOrder, validateAddress, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} xDeliverrSellerId
         * @param {WholesaleOrderUpsertRequestDTO} wholesaleOrderUpsertRequestDTO
         * @param {boolean} [submitOrder]
         * @param {boolean} [validateAddress]
         * @param {boolean} [validateInventory]
         * @param {boolean} [partialFill]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOrderAndShipmentsSync(xDeliverrSellerId, wholesaleOrderUpsertRequestDTO, submitOrder, validateAddress, validateInventory, partialFill, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOrderAndShipmentsSync(xDeliverrSellerId, wholesaleOrderUpsertRequestDTO, submitOrder, validateAddress, validateInventory, partialFill, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} transferId
         * @param {string} xDeliverrSellerId
         * @param {WholesaleOrderCreationRequestDTO} wholesaleOrderCreationRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTransfer(transferId, xDeliverrSellerId, wholesaleOrderCreationRequestDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTransfer(transferId, xDeliverrSellerId, wholesaleOrderCreationRequestDTO, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} shipmentId
         * @param {AttachmentType} attachmentType
         * @param {string} [orderId]
         * @param {string} [xDeliverrSellerId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteLabel(shipmentId, attachmentType, orderId, xDeliverrSellerId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteLabel(shipmentId, attachmentType, orderId, xDeliverrSellerId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {PurchaseLabelDTO} purchaseLabelDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateCaseLabelPdf(purchaseLabelDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateCaseLabelPdf(purchaseLabelDTO, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} shipmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateShipmentPackingList(shipmentId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateShipmentPackingList(shipmentId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHealthStatus(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHealthStatus(options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * returns the avialble inventory for a given SKU list in context of a specific sourceWarehouse and destinationChannelId
         * @summary get available inventory for a given SKU
         * @param {Array<string>} dskus the list of SKUs to be searched for inventory
         * @param {ExternalDestinationType} [targetId] the target to search for inventory
         * @param {Array<string>} [sourceWarehouses] warehouseIds to search for inventory
         * @param {InventoryPool} [inventoryPool] choose what kind of inventory pool to use (Defaults to STORAGE)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInventory(dskus, targetId, sourceWarehouses, inventoryPool, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInventory(dskus, targetId, sourceWarehouses, inventoryPool, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} orderId
         * @param {string} [xDeliverrSellerId]
         * @param {WholeEventVisibilityScope} [eventVisibility]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrderAndShipments(orderId, xDeliverrSellerId, eventVisibility, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrderAndShipments(orderId, xDeliverrSellerId, eventVisibility, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} shipmentId
         * @param {string} [xDeliverrSellerId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrderAndShipmentsByShipmentId(shipmentId, xDeliverrSellerId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrderAndShipmentsByShipmentId(shipmentId, xDeliverrSellerId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {WholesaleOrderStatus} [orderStatus]
         * @param {ExternalDestinationType} [externalDestinationType]
         * @param {string} [externalId]
         * @param {boolean} [includeArchived]
         * @param {string} [xDeliverrSellerId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrdersAndShipments(orderStatus, externalDestinationType, externalId, includeArchived, xDeliverrSellerId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrdersAndShipments(orderStatus, externalDestinationType, externalId, includeArchived, xDeliverrSellerId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} shipmentId
         * @param {string} [xDeliverrSellerId]
         * @param {string} [orderId]
         * @param {WholeEventVisibilityScope} [eventVisibility]
         * @param {boolean} [skipAttachmentByWarehouseType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getShipmentAdminAccess(shipmentId, xDeliverrSellerId, orderId, eventVisibility, skipAttachmentByWarehouseType, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getShipmentAdminAccess(shipmentId, xDeliverrSellerId, orderId, eventVisibility, skipAttachmentByWarehouseType, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} fulfillmentId
         * @param {string} [xDeliverrSellerId]
         * @param {string} [orderId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getShipmentByFulfillmentAdminAccess(fulfillmentId, xDeliverrSellerId, orderId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getShipmentByFulfillmentAdminAccess(fulfillmentId, xDeliverrSellerId, orderId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {Array<ShipmentProjectionKeys>} [projectionKeys]
         * @param {WholesaleShipmentStatus} [status]
         * @param {string} [originWarehouseId]
         * @param {Array<string>} [orderIds]
         * @param {WholesaleShippingMethod} [shippingMethod]
         * @param {WholesaleShipmentType} [shipmentType]
         * @param {OrderByColumn} [orderByColumn]
         * @param {OrderByDirection} [orderByDirection]
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async getShipments(projectionKeys, status, originWarehouseId, orderIds, shippingMethod, shipmentType, orderByColumn, orderByDirection, limit, offset, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getShipments(projectionKeys, status, originWarehouseId, orderIds, shippingMethod, shipmentType, orderByColumn, orderByDirection, limit, offset, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {Array<ShipmentProjectionKeys>} [projectionKeys]
         * @param {Array<WholesaleShipmentStatus>} [statuses]
         * @param {Array<string>} [originWarehouseIds]
         * @param {Array<string>} [orderIds]
         * @param {Array<WholesaleShippingMethod>} [shippingMethods]
         * @param {Array<WholesaleShipmentType>} [shipmentTypes]
         * @param {OrderByColumn} [orderByColumn]
         * @param {OrderByDirection} [orderByDirection]
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {string} [searchByExternalAttributeKey]
         * @param {string} [searchByExternalAttributeValue]
         * @param {WholeEventVisibilityScope} [eventVisibility]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getShipmentsV2(projectionKeys, statuses, originWarehouseIds, orderIds, shippingMethods, shipmentTypes, orderByColumn, orderByDirection, limit, offset, searchByExternalAttributeKey, searchByExternalAttributeValue, eventVisibility, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getShipmentsV2(projectionKeys, statuses, originWarehouseIds, orderIds, shippingMethods, shipmentTypes, orderByColumn, orderByDirection, limit, offset, searchByExternalAttributeKey, searchByExternalAttributeValue, eventVisibility, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {ExternalDestinationType} externalDestinationType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getValidAttributesV2(externalDestinationType, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getValidAttributesV2(externalDestinationType, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} shipmentId
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async getValidShipBy(shipmentId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getValidShipBy(shipmentId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} [shipmentId]
         * @param {string} [originWarehouseId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getValidShipByV2(shipmentId, originWarehouseId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getValidShipByV2(shipmentId, originWarehouseId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} orderId
         * @param {WholesaleShipmentCreationRequestDTO} wholesaleShipmentCreationRequestDTO
         * @param {string} [xDeliverrSellerId]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async overrideShipments(orderId, wholesaleShipmentCreationRequestDTO, xDeliverrSellerId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.overrideShipments(orderId, wholesaleShipmentCreationRequestDTO, xDeliverrSellerId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} orderId
         * @param {WholesaleOrderPatchDTO} wholesaleOrderPatchDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchOrderAdminAccess(orderId, wholesaleOrderPatchDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchOrderAdminAccess(orderId, wholesaleOrderPatchDTO, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} orderId
         * @param {WholesaleOrderSellerPatchDTO} wholesaleOrderSellerPatchDTO
         * @param {string} [xDeliverrSellerId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchOrderSellerAccess(orderId, wholesaleOrderSellerPatchDTO, xDeliverrSellerId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchOrderSellerAccess(orderId, wholesaleOrderSellerPatchDTO, xDeliverrSellerId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} shipmentId
         * @param {WholesaleShipmentPatchDTO} wholesaleShipmentPatchDTO
         * @param {string} [xDeliverrSellerId]
         * @param {string} [orderId]
         * @param {boolean} [shouldRerunEstimations]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchShipmentAdminAccess(shipmentId, wholesaleShipmentPatchDTO, xDeliverrSellerId, orderId, shouldRerunEstimations, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchShipmentAdminAccess(shipmentId, wholesaleShipmentPatchDTO, xDeliverrSellerId, orderId, shouldRerunEstimations, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} orderId
         * @param {WholesaleTestOrderPatchDTO} wholesaleTestOrderPatchDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchTestOrderAdminAccess(orderId, wholesaleTestOrderPatchDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchTestOrderAdminAccess(orderId, wholesaleTestOrderPatchDTO, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} shipmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async printCaseLabelPdf(shipmentId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.printCaseLabelPdf(shipmentId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {PurchaseLabelDTO} purchaseLabelDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async purchaseLabel(purchaseLabelDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.purchaseLabel(purchaseLabelDTO, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {InternalOpsSupportReleaseShipmentsDTO} internalOpsSupportReleaseShipmentsDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async releaseShipments(internalOpsSupportReleaseShipmentsDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.releaseShipments(internalOpsSupportReleaseShipmentsDTO, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} shipmentId
         * @param {AttachmentType} attachmentType
         * @param {string} [orderId]
         * @param {string} [xDeliverrSellerId]
         * @param {AttachmentMetaDataDTO} [attachmentMetaDataDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestLabelUploadAdminAccess(shipmentId, attachmentType, orderId, xDeliverrSellerId, attachmentMetaDataDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestLabelUploadAdminAccess(shipmentId, attachmentType, orderId, xDeliverrSellerId, attachmentMetaDataDTO, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} orderId
         * @param {string} [xDeliverrSellerId]
         * @param {boolean} [validateAddress]
         * @param {boolean} [partialFill]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submitOrderAndShipments(orderId, xDeliverrSellerId, validateAddress, partialFill, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submitOrderAndShipments(orderId, xDeliverrSellerId, validateAddress, partialFill, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} orderId
         * @param {string} xDeliverrSellerId
         * @param {WholesaleOrderUpsertRequestDTO} wholesaleOrderUpsertRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOrderAndShipments(orderId, xDeliverrSellerId, wholesaleOrderUpsertRequestDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOrderAndShipments(orderId, xDeliverrSellerId, wholesaleOrderUpsertRequestDTO, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {boolean} [fetchValidatedAddress]
         * @param {DeliverrAddress} [deliverrAddress]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateAddress(fetchValidatedAddress, deliverrAddress, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateAddress(fetchValidatedAddress, deliverrAddress, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
    };
};
exports.ServiceApiFp = ServiceApiFp;
/**
 * ServiceApi - factory interface
 * @export
 */
const ServiceApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.ServiceApiFp)(configuration);
    return {
        /**
         *
         * @param {WholesaleOrderAugmentRequestDTO} wholesaleOrderAugmentRequestDTO
         * @param {QuantityRoundingStrategy} [quantityRoundingStrategy]
         * @param {InventoryMissingStrategy} [inventoryRoundingStrategy]
         * @param {ParcelStrategyType} [parcelStrategy]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        augmentOrder(wholesaleOrderAugmentRequestDTO, quantityRoundingStrategy, inventoryRoundingStrategy, parcelStrategy, options) {
            return localVarFp.augmentOrder(wholesaleOrderAugmentRequestDTO, quantityRoundingStrategy, inventoryRoundingStrategy, parcelStrategy, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} orderId
         * @param {string} [xDeliverrSellerId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelOrderAndShipments(orderId, xDeliverrSellerId, options) {
            return localVarFp.cancelOrderAndShipments(orderId, xDeliverrSellerId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} transferId
         * @param {string} xDeliverrSellerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelTransferAndShipments(transferId, xDeliverrSellerId, options) {
            return localVarFp.cancelTransferAndShipments(transferId, xDeliverrSellerId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} xDeliverrSellerId
         * @param {WholesaleOrderUpsertRequestDTO} wholesaleOrderUpsertRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrderAndShipments(xDeliverrSellerId, wholesaleOrderUpsertRequestDTO, options) {
            return localVarFp.createOrderAndShipments(xDeliverrSellerId, wholesaleOrderUpsertRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} xDeliverrSellerId
         * @param {WholesaleOrderUpsertRequestDTO} wholesaleOrderUpsertRequestDTO
         * @param {boolean} [submitOrder]
         * @param {boolean} [validateAddress]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrderAndShipmentsInternal(xDeliverrSellerId, wholesaleOrderUpsertRequestDTO, submitOrder, validateAddress, options) {
            return localVarFp.createOrderAndShipmentsInternal(xDeliverrSellerId, wholesaleOrderUpsertRequestDTO, submitOrder, validateAddress, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} xDeliverrSellerId
         * @param {WholesaleOrderUpsertRequestDTO} wholesaleOrderUpsertRequestDTO
         * @param {boolean} [submitOrder]
         * @param {boolean} [validateAddress]
         * @param {boolean} [validateInventory]
         * @param {boolean} [partialFill]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrderAndShipmentsSync(xDeliverrSellerId, wholesaleOrderUpsertRequestDTO, submitOrder, validateAddress, validateInventory, partialFill, options) {
            return localVarFp.createOrderAndShipmentsSync(xDeliverrSellerId, wholesaleOrderUpsertRequestDTO, submitOrder, validateAddress, validateInventory, partialFill, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} transferId
         * @param {string} xDeliverrSellerId
         * @param {WholesaleOrderCreationRequestDTO} wholesaleOrderCreationRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTransfer(transferId, xDeliverrSellerId, wholesaleOrderCreationRequestDTO, options) {
            return localVarFp.createTransfer(transferId, xDeliverrSellerId, wholesaleOrderCreationRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} shipmentId
         * @param {AttachmentType} attachmentType
         * @param {string} [orderId]
         * @param {string} [xDeliverrSellerId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLabel(shipmentId, attachmentType, orderId, xDeliverrSellerId, options) {
            return localVarFp.deleteLabel(shipmentId, attachmentType, orderId, xDeliverrSellerId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PurchaseLabelDTO} purchaseLabelDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateCaseLabelPdf(purchaseLabelDTO, options) {
            return localVarFp.generateCaseLabelPdf(purchaseLabelDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} shipmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateShipmentPackingList(shipmentId, options) {
            return localVarFp.generateShipmentPackingList(shipmentId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHealthStatus(options) {
            return localVarFp.getHealthStatus(options).then((request) => request(axios, basePath));
        },
        /**
         * returns the avialble inventory for a given SKU list in context of a specific sourceWarehouse and destinationChannelId
         * @summary get available inventory for a given SKU
         * @param {Array<string>} dskus the list of SKUs to be searched for inventory
         * @param {ExternalDestinationType} [targetId] the target to search for inventory
         * @param {Array<string>} [sourceWarehouses] warehouseIds to search for inventory
         * @param {InventoryPool} [inventoryPool] choose what kind of inventory pool to use (Defaults to STORAGE)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInventory(dskus, targetId, sourceWarehouses, inventoryPool, options) {
            return localVarFp.getInventory(dskus, targetId, sourceWarehouses, inventoryPool, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} orderId
         * @param {string} [xDeliverrSellerId]
         * @param {WholeEventVisibilityScope} [eventVisibility]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderAndShipments(orderId, xDeliverrSellerId, eventVisibility, options) {
            return localVarFp.getOrderAndShipments(orderId, xDeliverrSellerId, eventVisibility, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} shipmentId
         * @param {string} [xDeliverrSellerId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderAndShipmentsByShipmentId(shipmentId, xDeliverrSellerId, options) {
            return localVarFp.getOrderAndShipmentsByShipmentId(shipmentId, xDeliverrSellerId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {WholesaleOrderStatus} [orderStatus]
         * @param {ExternalDestinationType} [externalDestinationType]
         * @param {string} [externalId]
         * @param {boolean} [includeArchived]
         * @param {string} [xDeliverrSellerId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrdersAndShipments(orderStatus, externalDestinationType, externalId, includeArchived, xDeliverrSellerId, options) {
            return localVarFp.getOrdersAndShipments(orderStatus, externalDestinationType, externalId, includeArchived, xDeliverrSellerId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} shipmentId
         * @param {string} [xDeliverrSellerId]
         * @param {string} [orderId]
         * @param {WholeEventVisibilityScope} [eventVisibility]
         * @param {boolean} [skipAttachmentByWarehouseType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShipmentAdminAccess(shipmentId, xDeliverrSellerId, orderId, eventVisibility, skipAttachmentByWarehouseType, options) {
            return localVarFp.getShipmentAdminAccess(shipmentId, xDeliverrSellerId, orderId, eventVisibility, skipAttachmentByWarehouseType, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} fulfillmentId
         * @param {string} [xDeliverrSellerId]
         * @param {string} [orderId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShipmentByFulfillmentAdminAccess(fulfillmentId, xDeliverrSellerId, orderId, options) {
            return localVarFp.getShipmentByFulfillmentAdminAccess(fulfillmentId, xDeliverrSellerId, orderId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<ShipmentProjectionKeys>} [projectionKeys]
         * @param {WholesaleShipmentStatus} [status]
         * @param {string} [originWarehouseId]
         * @param {Array<string>} [orderIds]
         * @param {WholesaleShippingMethod} [shippingMethod]
         * @param {WholesaleShipmentType} [shipmentType]
         * @param {OrderByColumn} [orderByColumn]
         * @param {OrderByDirection} [orderByDirection]
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getShipments(projectionKeys, status, originWarehouseId, orderIds, shippingMethod, shipmentType, orderByColumn, orderByDirection, limit, offset, options) {
            return localVarFp.getShipments(projectionKeys, status, originWarehouseId, orderIds, shippingMethod, shipmentType, orderByColumn, orderByDirection, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<ShipmentProjectionKeys>} [projectionKeys]
         * @param {Array<WholesaleShipmentStatus>} [statuses]
         * @param {Array<string>} [originWarehouseIds]
         * @param {Array<string>} [orderIds]
         * @param {Array<WholesaleShippingMethod>} [shippingMethods]
         * @param {Array<WholesaleShipmentType>} [shipmentTypes]
         * @param {OrderByColumn} [orderByColumn]
         * @param {OrderByDirection} [orderByDirection]
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {string} [searchByExternalAttributeKey]
         * @param {string} [searchByExternalAttributeValue]
         * @param {WholeEventVisibilityScope} [eventVisibility]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShipmentsV2(projectionKeys, statuses, originWarehouseIds, orderIds, shippingMethods, shipmentTypes, orderByColumn, orderByDirection, limit, offset, searchByExternalAttributeKey, searchByExternalAttributeValue, eventVisibility, options) {
            return localVarFp.getShipmentsV2(projectionKeys, statuses, originWarehouseIds, orderIds, shippingMethods, shipmentTypes, orderByColumn, orderByDirection, limit, offset, searchByExternalAttributeKey, searchByExternalAttributeValue, eventVisibility, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ExternalDestinationType} externalDestinationType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getValidAttributesV2(externalDestinationType, options) {
            return localVarFp.getValidAttributesV2(externalDestinationType, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} shipmentId
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getValidShipBy(shipmentId, options) {
            return localVarFp.getValidShipBy(shipmentId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [shipmentId]
         * @param {string} [originWarehouseId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getValidShipByV2(shipmentId, originWarehouseId, options) {
            return localVarFp.getValidShipByV2(shipmentId, originWarehouseId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} orderId
         * @param {WholesaleShipmentCreationRequestDTO} wholesaleShipmentCreationRequestDTO
         * @param {string} [xDeliverrSellerId]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        overrideShipments(orderId, wholesaleShipmentCreationRequestDTO, xDeliverrSellerId, options) {
            return localVarFp.overrideShipments(orderId, wholesaleShipmentCreationRequestDTO, xDeliverrSellerId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} orderId
         * @param {WholesaleOrderPatchDTO} wholesaleOrderPatchDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchOrderAdminAccess(orderId, wholesaleOrderPatchDTO, options) {
            return localVarFp.patchOrderAdminAccess(orderId, wholesaleOrderPatchDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} orderId
         * @param {WholesaleOrderSellerPatchDTO} wholesaleOrderSellerPatchDTO
         * @param {string} [xDeliverrSellerId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchOrderSellerAccess(orderId, wholesaleOrderSellerPatchDTO, xDeliverrSellerId, options) {
            return localVarFp.patchOrderSellerAccess(orderId, wholesaleOrderSellerPatchDTO, xDeliverrSellerId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} shipmentId
         * @param {WholesaleShipmentPatchDTO} wholesaleShipmentPatchDTO
         * @param {string} [xDeliverrSellerId]
         * @param {string} [orderId]
         * @param {boolean} [shouldRerunEstimations]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchShipmentAdminAccess(shipmentId, wholesaleShipmentPatchDTO, xDeliverrSellerId, orderId, shouldRerunEstimations, options) {
            return localVarFp.patchShipmentAdminAccess(shipmentId, wholesaleShipmentPatchDTO, xDeliverrSellerId, orderId, shouldRerunEstimations, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} orderId
         * @param {WholesaleTestOrderPatchDTO} wholesaleTestOrderPatchDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchTestOrderAdminAccess(orderId, wholesaleTestOrderPatchDTO, options) {
            return localVarFp.patchTestOrderAdminAccess(orderId, wholesaleTestOrderPatchDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} shipmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        printCaseLabelPdf(shipmentId, options) {
            return localVarFp.printCaseLabelPdf(shipmentId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PurchaseLabelDTO} purchaseLabelDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        purchaseLabel(purchaseLabelDTO, options) {
            return localVarFp.purchaseLabel(purchaseLabelDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {InternalOpsSupportReleaseShipmentsDTO} internalOpsSupportReleaseShipmentsDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        releaseShipments(internalOpsSupportReleaseShipmentsDTO, options) {
            return localVarFp.releaseShipments(internalOpsSupportReleaseShipmentsDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} shipmentId
         * @param {AttachmentType} attachmentType
         * @param {string} [orderId]
         * @param {string} [xDeliverrSellerId]
         * @param {AttachmentMetaDataDTO} [attachmentMetaDataDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestLabelUploadAdminAccess(shipmentId, attachmentType, orderId, xDeliverrSellerId, attachmentMetaDataDTO, options) {
            return localVarFp.requestLabelUploadAdminAccess(shipmentId, attachmentType, orderId, xDeliverrSellerId, attachmentMetaDataDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} orderId
         * @param {string} [xDeliverrSellerId]
         * @param {boolean} [validateAddress]
         * @param {boolean} [partialFill]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitOrderAndShipments(orderId, xDeliverrSellerId, validateAddress, partialFill, options) {
            return localVarFp.submitOrderAndShipments(orderId, xDeliverrSellerId, validateAddress, partialFill, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} orderId
         * @param {string} xDeliverrSellerId
         * @param {WholesaleOrderUpsertRequestDTO} wholesaleOrderUpsertRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrderAndShipments(orderId, xDeliverrSellerId, wholesaleOrderUpsertRequestDTO, options) {
            return localVarFp.updateOrderAndShipments(orderId, xDeliverrSellerId, wholesaleOrderUpsertRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {boolean} [fetchValidatedAddress]
         * @param {DeliverrAddress} [deliverrAddress]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateAddress(fetchValidatedAddress, deliverrAddress, options) {
            return localVarFp.validateAddress(fetchValidatedAddress, deliverrAddress, options).then((request) => request(axios, basePath));
        },
    };
};
exports.ServiceApiFactory = ServiceApiFactory;
/**
 * ServiceApi - object-oriented interface
 * @export
 * @class ServiceApi
 * @extends {BaseAPI}
 */
class ServiceApi extends base_1.BaseAPI {
    /**
     *
     * @param {WholesaleOrderAugmentRequestDTO} wholesaleOrderAugmentRequestDTO
     * @param {QuantityRoundingStrategy} [quantityRoundingStrategy]
     * @param {InventoryMissingStrategy} [inventoryRoundingStrategy]
     * @param {ParcelStrategyType} [parcelStrategy]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    augmentOrder(wholesaleOrderAugmentRequestDTO, quantityRoundingStrategy, inventoryRoundingStrategy, parcelStrategy, options) {
        return (0, exports.ServiceApiFp)(this.configuration).augmentOrder(wholesaleOrderAugmentRequestDTO, quantityRoundingStrategy, inventoryRoundingStrategy, parcelStrategy, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} orderId
     * @param {string} [xDeliverrSellerId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    cancelOrderAndShipments(orderId, xDeliverrSellerId, options) {
        return (0, exports.ServiceApiFp)(this.configuration).cancelOrderAndShipments(orderId, xDeliverrSellerId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} transferId
     * @param {string} xDeliverrSellerId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    cancelTransferAndShipments(transferId, xDeliverrSellerId, options) {
        return (0, exports.ServiceApiFp)(this.configuration).cancelTransferAndShipments(transferId, xDeliverrSellerId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} xDeliverrSellerId
     * @param {WholesaleOrderUpsertRequestDTO} wholesaleOrderUpsertRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    createOrderAndShipments(xDeliverrSellerId, wholesaleOrderUpsertRequestDTO, options) {
        return (0, exports.ServiceApiFp)(this.configuration).createOrderAndShipments(xDeliverrSellerId, wholesaleOrderUpsertRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} xDeliverrSellerId
     * @param {WholesaleOrderUpsertRequestDTO} wholesaleOrderUpsertRequestDTO
     * @param {boolean} [submitOrder]
     * @param {boolean} [validateAddress]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    createOrderAndShipmentsInternal(xDeliverrSellerId, wholesaleOrderUpsertRequestDTO, submitOrder, validateAddress, options) {
        return (0, exports.ServiceApiFp)(this.configuration).createOrderAndShipmentsInternal(xDeliverrSellerId, wholesaleOrderUpsertRequestDTO, submitOrder, validateAddress, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} xDeliverrSellerId
     * @param {WholesaleOrderUpsertRequestDTO} wholesaleOrderUpsertRequestDTO
     * @param {boolean} [submitOrder]
     * @param {boolean} [validateAddress]
     * @param {boolean} [validateInventory]
     * @param {boolean} [partialFill]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    createOrderAndShipmentsSync(xDeliverrSellerId, wholesaleOrderUpsertRequestDTO, submitOrder, validateAddress, validateInventory, partialFill, options) {
        return (0, exports.ServiceApiFp)(this.configuration).createOrderAndShipmentsSync(xDeliverrSellerId, wholesaleOrderUpsertRequestDTO, submitOrder, validateAddress, validateInventory, partialFill, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} transferId
     * @param {string} xDeliverrSellerId
     * @param {WholesaleOrderCreationRequestDTO} wholesaleOrderCreationRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    createTransfer(transferId, xDeliverrSellerId, wholesaleOrderCreationRequestDTO, options) {
        return (0, exports.ServiceApiFp)(this.configuration).createTransfer(transferId, xDeliverrSellerId, wholesaleOrderCreationRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} shipmentId
     * @param {AttachmentType} attachmentType
     * @param {string} [orderId]
     * @param {string} [xDeliverrSellerId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    deleteLabel(shipmentId, attachmentType, orderId, xDeliverrSellerId, options) {
        return (0, exports.ServiceApiFp)(this.configuration).deleteLabel(shipmentId, attachmentType, orderId, xDeliverrSellerId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PurchaseLabelDTO} purchaseLabelDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    generateCaseLabelPdf(purchaseLabelDTO, options) {
        return (0, exports.ServiceApiFp)(this.configuration).generateCaseLabelPdf(purchaseLabelDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} shipmentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    generateShipmentPackingList(shipmentId, options) {
        return (0, exports.ServiceApiFp)(this.configuration).generateShipmentPackingList(shipmentId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    getHealthStatus(options) {
        return (0, exports.ServiceApiFp)(this.configuration).getHealthStatus(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * returns the avialble inventory for a given SKU list in context of a specific sourceWarehouse and destinationChannelId
     * @summary get available inventory for a given SKU
     * @param {Array<string>} dskus the list of SKUs to be searched for inventory
     * @param {ExternalDestinationType} [targetId] the target to search for inventory
     * @param {Array<string>} [sourceWarehouses] warehouseIds to search for inventory
     * @param {InventoryPool} [inventoryPool] choose what kind of inventory pool to use (Defaults to STORAGE)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    getInventory(dskus, targetId, sourceWarehouses, inventoryPool, options) {
        return (0, exports.ServiceApiFp)(this.configuration).getInventory(dskus, targetId, sourceWarehouses, inventoryPool, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} orderId
     * @param {string} [xDeliverrSellerId]
     * @param {WholeEventVisibilityScope} [eventVisibility]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    getOrderAndShipments(orderId, xDeliverrSellerId, eventVisibility, options) {
        return (0, exports.ServiceApiFp)(this.configuration).getOrderAndShipments(orderId, xDeliverrSellerId, eventVisibility, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} shipmentId
     * @param {string} [xDeliverrSellerId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    getOrderAndShipmentsByShipmentId(shipmentId, xDeliverrSellerId, options) {
        return (0, exports.ServiceApiFp)(this.configuration).getOrderAndShipmentsByShipmentId(shipmentId, xDeliverrSellerId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {WholesaleOrderStatus} [orderStatus]
     * @param {ExternalDestinationType} [externalDestinationType]
     * @param {string} [externalId]
     * @param {boolean} [includeArchived]
     * @param {string} [xDeliverrSellerId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    getOrdersAndShipments(orderStatus, externalDestinationType, externalId, includeArchived, xDeliverrSellerId, options) {
        return (0, exports.ServiceApiFp)(this.configuration).getOrdersAndShipments(orderStatus, externalDestinationType, externalId, includeArchived, xDeliverrSellerId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} shipmentId
     * @param {string} [xDeliverrSellerId]
     * @param {string} [orderId]
     * @param {WholeEventVisibilityScope} [eventVisibility]
     * @param {boolean} [skipAttachmentByWarehouseType]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    getShipmentAdminAccess(shipmentId, xDeliverrSellerId, orderId, eventVisibility, skipAttachmentByWarehouseType, options) {
        return (0, exports.ServiceApiFp)(this.configuration).getShipmentAdminAccess(shipmentId, xDeliverrSellerId, orderId, eventVisibility, skipAttachmentByWarehouseType, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} fulfillmentId
     * @param {string} [xDeliverrSellerId]
     * @param {string} [orderId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    getShipmentByFulfillmentAdminAccess(fulfillmentId, xDeliverrSellerId, orderId, options) {
        return (0, exports.ServiceApiFp)(this.configuration).getShipmentByFulfillmentAdminAccess(fulfillmentId, xDeliverrSellerId, orderId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<ShipmentProjectionKeys>} [projectionKeys]
     * @param {WholesaleShipmentStatus} [status]
     * @param {string} [originWarehouseId]
     * @param {Array<string>} [orderIds]
     * @param {WholesaleShippingMethod} [shippingMethod]
     * @param {WholesaleShipmentType} [shipmentType]
     * @param {OrderByColumn} [orderByColumn]
     * @param {OrderByDirection} [orderByDirection]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    getShipments(projectionKeys, status, originWarehouseId, orderIds, shippingMethod, shipmentType, orderByColumn, orderByDirection, limit, offset, options) {
        return (0, exports.ServiceApiFp)(this.configuration).getShipments(projectionKeys, status, originWarehouseId, orderIds, shippingMethod, shipmentType, orderByColumn, orderByDirection, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<ShipmentProjectionKeys>} [projectionKeys]
     * @param {Array<WholesaleShipmentStatus>} [statuses]
     * @param {Array<string>} [originWarehouseIds]
     * @param {Array<string>} [orderIds]
     * @param {Array<WholesaleShippingMethod>} [shippingMethods]
     * @param {Array<WholesaleShipmentType>} [shipmentTypes]
     * @param {OrderByColumn} [orderByColumn]
     * @param {OrderByDirection} [orderByDirection]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchByExternalAttributeKey]
     * @param {string} [searchByExternalAttributeValue]
     * @param {WholeEventVisibilityScope} [eventVisibility]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    getShipmentsV2(projectionKeys, statuses, originWarehouseIds, orderIds, shippingMethods, shipmentTypes, orderByColumn, orderByDirection, limit, offset, searchByExternalAttributeKey, searchByExternalAttributeValue, eventVisibility, options) {
        return (0, exports.ServiceApiFp)(this.configuration).getShipmentsV2(projectionKeys, statuses, originWarehouseIds, orderIds, shippingMethods, shipmentTypes, orderByColumn, orderByDirection, limit, offset, searchByExternalAttributeKey, searchByExternalAttributeValue, eventVisibility, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ExternalDestinationType} externalDestinationType
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    getValidAttributesV2(externalDestinationType, options) {
        return (0, exports.ServiceApiFp)(this.configuration).getValidAttributesV2(externalDestinationType, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} shipmentId
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    getValidShipBy(shipmentId, options) {
        return (0, exports.ServiceApiFp)(this.configuration).getValidShipBy(shipmentId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [shipmentId]
     * @param {string} [originWarehouseId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    getValidShipByV2(shipmentId, originWarehouseId, options) {
        return (0, exports.ServiceApiFp)(this.configuration).getValidShipByV2(shipmentId, originWarehouseId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} orderId
     * @param {WholesaleShipmentCreationRequestDTO} wholesaleShipmentCreationRequestDTO
     * @param {string} [xDeliverrSellerId]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    overrideShipments(orderId, wholesaleShipmentCreationRequestDTO, xDeliverrSellerId, options) {
        return (0, exports.ServiceApiFp)(this.configuration).overrideShipments(orderId, wholesaleShipmentCreationRequestDTO, xDeliverrSellerId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} orderId
     * @param {WholesaleOrderPatchDTO} wholesaleOrderPatchDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    patchOrderAdminAccess(orderId, wholesaleOrderPatchDTO, options) {
        return (0, exports.ServiceApiFp)(this.configuration).patchOrderAdminAccess(orderId, wholesaleOrderPatchDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} orderId
     * @param {WholesaleOrderSellerPatchDTO} wholesaleOrderSellerPatchDTO
     * @param {string} [xDeliverrSellerId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    patchOrderSellerAccess(orderId, wholesaleOrderSellerPatchDTO, xDeliverrSellerId, options) {
        return (0, exports.ServiceApiFp)(this.configuration).patchOrderSellerAccess(orderId, wholesaleOrderSellerPatchDTO, xDeliverrSellerId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} shipmentId
     * @param {WholesaleShipmentPatchDTO} wholesaleShipmentPatchDTO
     * @param {string} [xDeliverrSellerId]
     * @param {string} [orderId]
     * @param {boolean} [shouldRerunEstimations]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    patchShipmentAdminAccess(shipmentId, wholesaleShipmentPatchDTO, xDeliverrSellerId, orderId, shouldRerunEstimations, options) {
        return (0, exports.ServiceApiFp)(this.configuration).patchShipmentAdminAccess(shipmentId, wholesaleShipmentPatchDTO, xDeliverrSellerId, orderId, shouldRerunEstimations, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} orderId
     * @param {WholesaleTestOrderPatchDTO} wholesaleTestOrderPatchDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    patchTestOrderAdminAccess(orderId, wholesaleTestOrderPatchDTO, options) {
        return (0, exports.ServiceApiFp)(this.configuration).patchTestOrderAdminAccess(orderId, wholesaleTestOrderPatchDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} shipmentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    printCaseLabelPdf(shipmentId, options) {
        return (0, exports.ServiceApiFp)(this.configuration).printCaseLabelPdf(shipmentId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PurchaseLabelDTO} purchaseLabelDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    purchaseLabel(purchaseLabelDTO, options) {
        return (0, exports.ServiceApiFp)(this.configuration).purchaseLabel(purchaseLabelDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {InternalOpsSupportReleaseShipmentsDTO} internalOpsSupportReleaseShipmentsDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    releaseShipments(internalOpsSupportReleaseShipmentsDTO, options) {
        return (0, exports.ServiceApiFp)(this.configuration).releaseShipments(internalOpsSupportReleaseShipmentsDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} shipmentId
     * @param {AttachmentType} attachmentType
     * @param {string} [orderId]
     * @param {string} [xDeliverrSellerId]
     * @param {AttachmentMetaDataDTO} [attachmentMetaDataDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    requestLabelUploadAdminAccess(shipmentId, attachmentType, orderId, xDeliverrSellerId, attachmentMetaDataDTO, options) {
        return (0, exports.ServiceApiFp)(this.configuration).requestLabelUploadAdminAccess(shipmentId, attachmentType, orderId, xDeliverrSellerId, attachmentMetaDataDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} orderId
     * @param {string} [xDeliverrSellerId]
     * @param {boolean} [validateAddress]
     * @param {boolean} [partialFill]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    submitOrderAndShipments(orderId, xDeliverrSellerId, validateAddress, partialFill, options) {
        return (0, exports.ServiceApiFp)(this.configuration).submitOrderAndShipments(orderId, xDeliverrSellerId, validateAddress, partialFill, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} orderId
     * @param {string} xDeliverrSellerId
     * @param {WholesaleOrderUpsertRequestDTO} wholesaleOrderUpsertRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    updateOrderAndShipments(orderId, xDeliverrSellerId, wholesaleOrderUpsertRequestDTO, options) {
        return (0, exports.ServiceApiFp)(this.configuration).updateOrderAndShipments(orderId, xDeliverrSellerId, wholesaleOrderUpsertRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {boolean} [fetchValidatedAddress]
     * @param {DeliverrAddress} [deliverrAddress]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    validateAddress(fetchValidatedAddress, deliverrAddress, options) {
        return (0, exports.ServiceApiFp)(this.configuration).validateAddress(fetchValidatedAddress, deliverrAddress, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.ServiceApi = ServiceApi;
//# sourceMappingURL=service-api.js.map